import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=03728103&scoped=true&"
import script from "./CommonTable.vue?vue&type=script&lang=js&"
export * from "./CommonTable.vue?vue&type=script&lang=js&"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=03728103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03728103",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03728103')) {
      api.createRecord('03728103', component.options)
    } else {
      api.reload('03728103', component.options)
    }
    module.hot.accept("./CommonTable.vue?vue&type=template&id=03728103&scoped=true&", function () {
      api.rerender('03728103', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/CommonTable.vue"
export default component.exports